<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title">
      <i class="back-btn" @click="goBack"></i>充值账户地址
    </div>
    <div class="qrcode-wrap">
      <div class="qrCodeUrl">
         <div id="qrcode" ></div>
      </div>
      <div class="qrcode-notice">扫描二维码进行充值</div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "Qrcode",
  data() {
    return {
      qrcode: "",
      params: {}
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: this.params.back });
    }
  },
  created() {
  },
  mounted() {
	  this.params = this.$store.state.routerStore.qrcode;
      this.qrcode = new QRCode("qrcode", {
      text: this.params.qrCodeUrl,
      width: 240,
      height: 240,
      // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      colorDark: "#000000", //#前景色
      colorLight: "#ffffff", //#背景色
      correctLevel: 3
    });
  }
};
</script>

<style lang="less" scoped>
.qrcode-wrap {
  position: absolute;
  width: 240px;
  height: 240px;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
.qrCodeUrl,
img {
  width: 100%;
  height: 100%;
}
.qrcode-notice {
  padding-top: 30px;
  font-size: 12px !important;
  color: #96abe4;
  text-align: center;
}
</style>